import { h } from 'vue'

export default {
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props, { attrs }) {
    const svg = (children) => h(
      'svg',
      {
        ...attrs,
        class: ['view-mode-icon', attrs.class],
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        'aria-hidden': 'true',
        focusable: 'false',
      },
      children,
    )
    const rect = (x, y, width, height, radius = 1.5) => h('rect', {
      x,
      y,
      width,
      height,
      rx: radius,
      fill: 'currentColor',
    })
    const line = (x1, y1, x2, y2, width = 2.2) => h('path', {
      d: `M${x1} ${y1}H${x2}`,
      stroke: 'currentColor',
      'stroke-width': width,
      'stroke-linecap': 'round',
    })

    return () => {
      if (props.mode === '2') {
        return svg([
          rect(3, 3, 8, 8, 1.2),
          rect(13, 3, 8, 8, 1.2),
          rect(3, 13, 8, 8, 1.2),
          rect(13, 13, 8, 8, 1.2),
        ])
      }
      if (props.mode === '3') {
        return svg([
          rect(3, 5, 3.2, 3.2, 1.2),
          line(9.5, 6.6, 19.8, 6.6, 2.4),
          rect(3, 11, 3.2, 3.2, 1.2),
          line(9.5, 12.6, 19.8, 12.6, 2.4),
          rect(3, 17, 3.2, 3.2, 1.2),
          line(9.5, 18.6, 19.8, 18.6, 2.4),
        ])
      }
      if (props.mode === '4') {
        return svg([
          line(5, 6, 19, 6, 2.4),
          line(5, 12, 19, 12, 2.4),
          line(5, 18, 19, 18, 2.4),
        ])
      }
      return svg([
        rect(2.5, 4, 10, 16, 1.2),
        line(15, 6, 20.5, 6, 2.2),
        line(15, 12, 20.5, 12, 2.2),
        line(15, 18, 20.5, 18, 2.2),
      ])
    }
  },
}
